// extracted by mini-css-extract-plugin
export default {"heading":"RjEmX8","subheading":"Z6nEPb"};